import BaseSetup from '@/components/BaseSetup';

export type SharedSelectAssigneeEmits = { (e: 'update:modelValue' | 'input', val: Undef<number>): void };
export type SharedSelectAssigneeProps = {
	modelValue?: number
	options: IUserAgencyForListModel[]
};

export default class SharedSelectAssigneeSetup extends BaseSetup {

	static readonly defaultProps = {};

	get userId () { return this.props.modelValue }
	set userId (val) {
		this.emits('update:modelValue', val);
		this.emits('input', val);
	}

	constructor (
		private props: SharedSelectAssigneeProps,
		private emits: SharedSelectAssigneeEmits,
	) {
		super();
	}

}
